import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const TABS = [
  { name: 'Family',       tKey: 'parent_footer.family', icon: '👨‍👩‍👧‍👦', to: '/parent'              },
  { name: 'Subscription', tKey: 'parent_footer.sub',    icon: '💳',      to: '/parent/subscription' },
  { name: 'More',         tKey: 'parent_footer.more',   icon: '⚙️',      to: '/parent/more'         },
] as const;

interface ParentBottomTabBarProps {
  activeTab: string;
}

export function ParentBottomTabBar({ activeTab }: ParentBottomTabBarProps) {
  const { t } = useTranslation();
  return (
    <nav className="tab-bar">
      {TABS.map((tab) => (
        <Link
          key={tab.name}
          to={tab.to}
          className={`tab-item${activeTab === tab.name ? ' active' : ''}`}
        >
          <span className="tab-icon">{tab.icon}</span>
          <span>{t(tab.tKey)}</span>
        </Link>
      ))}
    </nav>
  );
}
